@if(isBrowser){
<footer id="footer">
    <!-- Top nav with mountain background -->
    <div class="footer-nav"
        style="background-image: url('../../../assets/images/footer-bg.webp');">
        <div class="container">
            <div class="row footer-nav__row">
                <!-- Locations -->
                <div class="col-12 col-lg footer-nav__col"
                    [class.is-open]="isNavOpen('locations')">
                    <div class="footer-nav__heading"
                        (click)="toggleNavSection('locations')">
                        <span class="footer-nav__icon" aria-hidden="true">
                            <svg width="29" height="29" viewBox="0 0 29 29"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_6937_1303)">
                                    <path
                                        d="M14.5 0C9.40433 0 5.1543 4.10475 5.1543 9.3457C5.1543 11.3396 5.75344 13.1175 6.9033 14.7835L13.7848 25.5215C14.1186 26.0435 14.882 26.0425 15.2152 25.5215L22.1265 14.747C23.2517 13.1565 23.8457 11.2889 23.8457 9.3457C23.8457 4.19248 19.6532 0 14.5 0ZM14.5 13.5938C12.1577 13.5938 10.252 11.688 10.252 9.3457C10.252 7.00344 12.1577 5.09766 14.5 5.09766C16.8423 5.09766 18.748 7.00344 18.748 9.3457C18.748 11.688 16.8423 13.5938 14.5 13.5938Z"
                                        fill="#FB6638" />
                                    <path
                                        d="M21.1419 19.5234L16.8638 26.212C15.7564 27.9385 13.2374 27.9328 12.1354 26.2136L7.85028 19.5252C4.08005 20.3969 1.75586 21.9938 1.75586 23.902C1.75586 27.2134 8.32209 28.9997 14.5 28.9997C20.6779 28.9997 27.2441 27.2134 27.2441 23.902C27.2441 21.9924 24.9167 20.3947 21.1419 19.5234Z"
                                        fill="#FB6638" />
                                </g>
                                <defs>
                                    <clippath id="clip0_6937_1303">
                                        <rect width="29" height="29"
                                            fill="white" />
                                    </clippath>
                                </defs>
                            </svg>

                        </span>
                        <div class="footer-nav__title">Locations</div>
                        <span class="footer-nav__chevron" aria-hidden="true">
                            <svg width="14" height="14" viewBox="0 0 14 14"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 5.25L7 8.75L10.5 5.25"
                                    stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                    </div>
                    <ul class="footer-nav__links">
                        @for(countries of locationList; track countries){
                        <li>
                            <a href="javascript:void(0)"
                                [routerLink]="['/location-region', countries.slug]">{{countries?.name}}</a>
                        </li>
                        }
                        <li>
                            <a href="javascript:void(0)"
                                routerLink="/locations">View All Locations</a>
                        </li>
                    </ul>
                </div>

                <!-- Experiences -->
                <div class="col-12 col-lg footer-nav__col"
                    [class.is-open]="isNavOpen('experiences')">
                    <div class="footer-nav__heading"
                        (click)="toggleNavSection('experiences')">
                        <span class="footer-nav__icon" aria-hidden="true">
                            <svg width="26" height="26" viewBox="0 0 26 26"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12.7374 0C5.70636 0 0 5.80475 0 12.957C0 20.1093 5.70636 25.9141 12.7374 25.9141C19.7685 25.9141 25.4748 20.1093 25.4748 12.957C25.4748 5.80475 19.7685 0 12.7374 0ZM19.3609 7.0659L16.1595 14.9611C15.8962 15.6348 15.3697 16.1704 14.7075 16.4382L6.94614 19.6947C6.41966 19.9106 5.90167 19.3837 6.11396 18.8482L9.3153 10.953C9.57862 10.2792 10.1051 9.74369 10.7674 9.47591L18.5287 6.21937C19.0552 6.00342 19.5732 6.53034 19.3609 7.0659Z"
                                    fill="#FB6638" />
                                <path
                                    d="M12.7374 14.6857C13.6753 14.6857 14.4357 13.9122 14.4357 12.9581C14.4357 12.0039 13.6753 11.2305 12.7374 11.2305C11.7994 11.2305 11.0391 12.0039 11.0391 12.9581C11.0391 13.9122 11.7994 14.6857 12.7374 14.6857Z"
                                    fill="#FB6638" />
                            </svg>

                        </span>
                        <div class="footer-nav__title">Experiences</div>
                        <span class="footer-nav__chevron" aria-hidden="true">
                            <svg width="14" height="14" viewBox="0 0 14 14"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 5.25L7 8.75L10.5 5.25"
                                    stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                    </div>
                    <ul class="footer-nav__links">
                        @for(category of categoryList; track category){
                        <li>
                            <a href="javascript:void(0)"
                                [routerLink]="['/experience', category.slug]">{{category?.name}}</a>
                        </li>
                        }
                        <li>
                            <a href="javascript:void(0)"
                                routerLink="/at-home-experiences">At Home
                                Experiences</a>
                        </li>
                    </ul>
                </div>

                <!-- Gift Ideas -->
                <div class="col-12 col-lg footer-nav__col"
                    [class.is-open]="isNavOpen('gifts')">
                    <div class="footer-nav__heading"
                        (click)="toggleNavSection('gifts')">
                        <span class="footer-nav__icon" aria-hidden="true">
                            <svg width="26" height="26" viewBox="0 0 26 26"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.33 14.3906C9.13108 14.3906 2.65933 14.3906 2.65933 14.3906C1.97231 14.3906 1.41016 14.9362 1.41016 15.603V24.7028C1.41016 25.3697 1.97231 25.9152 2.65933 25.9152C2.65933 25.9152 9.2665 25.9152 11.4758 25.9152C11.7697 25.9152 11.7697 25.6088 11.7697 25.6088V14.8026C11.7697 14.8026 11.7696 14.3906 11.33 14.3906Z"
                                    fill="#FB6638" />
                                <path
                                    d="M22.9896 14.3906C22.9896 14.3906 16.4931 14.3906 14.3278 14.3906C13.8002 14.3906 13.8792 14.9239 13.8792 14.9239V25.6187C13.8792 25.6187 13.8749 25.9149 14.1923 25.9149C16.3916 25.9149 22.9894 25.9149 22.9894 25.9149C23.6765 25.9149 24.2386 25.3694 24.2386 24.7026V15.603C24.2388 14.9362 23.6766 14.3906 22.9896 14.3906Z"
                                    fill="#FB6638" />
                                <path
                                    d="M11.77 7.23114C11.77 7.23114 11.77 6.82031 11.3518 6.82031C8.84715 6.82031 1.24917 6.82031 1.24917 6.82031C0.562156 6.82031 0 7.36593 0 8.03266V11.8172C0 12.484 0.562156 13.0296 1.24917 13.0296C1.24917 13.0296 8.88119 13.0296 11.386 13.0296C11.77 13.0296 11.77 12.7063 11.77 12.7063V7.23114Z"
                                    fill="#FB6638" />
                                <path
                                    d="M24.4007 6.82031C24.4007 6.82031 16.7996 6.82031 14.2658 6.82031C13.8799 6.82031 13.8799 7.17726 13.8799 7.17726V12.7138C13.8799 12.7138 13.8799 13.0296 14.3491 13.0296C16.8619 13.0296 24.4007 13.0296 24.4007 13.0296C25.0877 13.0296 25.6498 12.484 25.6498 11.8172V8.03266C25.6498 7.36593 25.0877 6.82031 24.4007 6.82031Z"
                                    fill="#FB6638" />
                                <path
                                    d="M7.52162 5.92172C6.95009 5.92172 6.42807 5.87773 5.9703 5.7909C4.80758 5.57043 4.00844 5.14132 3.52719 4.47919C3.096 3.88578 2.96404 3.15422 3.13486 2.30474C3.43409 0.818476 4.46248 0 6.03037 0C6.36218 0 6.72658 0.0371874 7.11354 0.110591C8.09788 0.297234 9.35689 0.845064 10.4815 1.576C12.3895 2.81626 12.4838 3.58731 12.3888 4.05944C12.2491 4.75319 11.581 5.2489 10.3463 5.57502C9.51215 5.79532 8.48257 5.92172 7.52162 5.92172ZM6.03046 1.9432C5.42325 1.9432 5.21457 2.10785 5.09999 2.67732C5.00625 3.14291 5.12447 3.30553 5.16324 3.35897C5.3256 3.58245 5.74851 3.76883 6.35417 3.88357C6.68098 3.94558 7.08478 3.97835 7.52153 3.97835C8.48194 3.97835 9.32804 3.83711 9.88946 3.68261C9.93033 3.6714 9.99376 3.62449 9.92578 3.58519C9.1918 3.00485 7.84898 2.22992 6.72967 2.01766C6.46893 1.96837 6.23359 1.9432 6.03046 1.9432Z"
                                    fill="#FB6638" />
                                <path
                                    d="M18.1574 5.92163C18.1574 5.92163 18.1574 5.92163 18.1572 5.92163C17.1962 5.92163 16.1668 5.79523 15.3326 5.57493C14.0978 5.2489 13.4298 4.7531 13.2901 4.05944C13.1952 3.58731 13.2894 2.81626 15.1975 1.576C16.3219 0.845064 17.5809 0.297234 18.5655 0.110591C18.9524 0.0371874 19.3168 0 19.6484 0C21.2166 0 22.2449 0.818565 22.5439 2.30483C22.7149 3.15422 22.583 3.88578 22.1517 4.47919C21.6705 5.1414 20.8714 5.57043 19.7084 5.7909C19.2508 5.87756 18.7288 5.92163 18.1574 5.92163ZM15.7692 3.57308C15.7041 3.60974 15.7356 3.6676 15.7693 3.67705C16.3305 3.83366 17.1855 3.97835 18.1572 3.97835C18.5941 3.97835 18.9977 3.94558 19.3246 3.88357C19.9302 3.76874 20.3533 3.58245 20.5156 3.35897C20.5545 3.30553 20.6728 3.14291 20.5788 2.67732C20.4643 2.10785 20.2556 1.9432 19.6483 1.9432C19.4452 1.9432 19.2101 1.96828 18.9491 2.01775C17.8298 2.22992 16.5031 2.99266 15.7692 3.57308Z"
                                    fill="#FB6638" />
                            </svg>

                        </span>
                        <div class="footer-nav__title">Gift Ideas</div>
                        <span class="footer-nav__chevron" aria-hidden="true">
                            <svg width="14" height="14" viewBox="0 0 14 14"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 5.25L7 8.75L10.5 5.25"
                                    stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                    </div>
                    <ul class="footer-nav__links">
                        @for(giftIdea of giftIdeasList; track giftIdea){
                        <li>
                            <a href="javascript:void(0)"
                                [routerLink]="giftIdea.slug === 'gift-ideas' ? '/gifts' : ['/gifts', giftIdea.slug]">{{giftIdea.name}}</a>
                        </li>
                        }
                    </ul>
                </div>

                <!-- Wedding Registry -->
                <div class="col-12 col-lg footer-nav__col"
                    [class.is-open]="isNavOpen('registry')">
                    <div class="footer-nav__heading"
                        (click)="toggleNavSection('registry')">
                        <span class="footer-nav__icon" aria-hidden="true">
                            <svg width="23" height="25" viewBox="0 0 23 25"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12.4248 5.46311L15.3101 2.99133C15.5685 2.76946 15.6314 2.39419 15.4588 2.10055L14.4277 0.34712C14.3011 0.131812 14.0703 0 13.8212 0H11.4097H8.99812C8.74903 0 8.51824 0.131812 8.39159 0.34712L7.36055 2.10055C7.18793 2.39419 7.25079 2.76946 7.50925 2.99133L10.3942 5.46311C5.75972 5.97577 2.10449 9.95011 2.10449 14.7118C2.10449 19.8165 6.30498 24.017 11.4097 24.017C16.5144 24.017 20.7148 19.8165 20.7148 14.7118C20.7148 9.94997 17.0595 5.97554 12.4248 5.46311ZM11.4097 21.0918C7.88592 21.0918 5.02969 18.2355 5.02969 14.7118C5.02969 11.1881 7.88592 8.33183 11.4097 8.33183C14.9096 8.33183 17.7896 11.2118 17.7896 14.7118C17.7896 18.2118 14.9096 21.0918 11.4097 21.0918Z"
                                    fill="#FB6638" />
                                <path
                                    d="M17.86 3.50119C18.1775 3.72063 18.6194 3.63995 18.8389 3.32242L19.7117 2.05956C19.9312 1.74204 19.8505 1.30017 19.533 1.08068C19.2155 0.8612 18.7736 0.941882 18.5541 1.25945L17.6813 2.52231C17.4618 2.83983 17.5425 3.28175 17.86 3.50119Z"
                                    fill="#FB6638" />
                                <path
                                    d="M22.6703 3.2612C22.4325 2.9571 21.9867 2.90245 21.6826 3.14018L20.4731 4.08562C20.169 4.32335 20.1144 4.76921 20.3521 5.07331C20.5898 5.37742 21.0357 5.43207 21.3398 5.19434L22.5493 4.2489C22.8533 4.01117 22.908 3.56531 22.6703 3.2612Z"
                                    fill="#FB6638" />
                                <path
                                    d="M3.97891 3.3226C4.19839 3.64013 4.64027 3.72081 4.95779 3.50137C5.27531 3.28194 5.35599 2.84001 5.13655 2.52249L4.26369 1.25963C4.0442 0.94211 3.60233 0.861428 3.28481 1.08086C2.96729 1.3003 2.8866 1.74222 3.10604 2.05974L3.97891 3.3226Z"
                                    fill="#FB6638" />
                                <path
                                    d="M2.4662 5.07331C2.70393 4.76921 2.64928 4.32335 2.34517 4.08562L1.13569 3.14018C0.831587 2.90245 0.385724 2.9571 0.147994 3.2612C-0.0897366 3.56531 -0.0350886 4.01117 0.269017 4.2489L1.47854 5.19434C1.78265 5.43207 2.22851 5.37742 2.4662 5.07331Z"
                                    fill="#FB6638" />
                            </svg>

                        </span>
                        <div class="footer-nav__title">Wedding Registry</div>
                        <span class="footer-nav__chevron" aria-hidden="true">
                            <svg width="14" height="14" viewBox="0 0 14 14"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 5.25L7 8.75L10.5 5.25"
                                    stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                    </div>
                    <ul class="footer-nav__links">
                        <li><a href="javascript:void(0)"
                                routerLink="/registration/wedding-couple">Create
                                a Registry</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/find-couple">Find a Couple</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/theknot">The Knot</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/joy">Joy</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/zola">Zola</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/tiktok">Tiktok</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/howitwork">How Registries
                                Work</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/wedding-registry">Why Register With
                                Spur</a></li>
                    </ul>
                </div>

                <!-- About -->
                <div class="col-12 col-lg footer-nav__col"
                    [class.is-open]="isNavOpen('about')">
                    <div class="footer-nav__heading"
                        (click)="toggleNavSection('about')">
                        <span class="footer-nav__icon" aria-hidden="true">
                            <svg width="24" height="24" viewBox="0 0 24 24"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_6937_1336)">
                                    <path
                                        d="M12 0C5.3833 0 0 5.3833 0 12C0 18.6168 5.3833 24 12 24C18.6168 24 24 18.6168 24 12C24 5.3833 18.6167 0 12 0ZM12.7806 19.1199C12.2105 19.215 11.0761 19.4523 10.5 19.5C10.0124 19.5404 9.55225 19.2613 9.27175 18.8606C8.99052 18.46 8.92313 17.9473 9.09009 17.4873L11.3584 11.25H8.99999C8.99798 9.95036 9.97284 8.99473 11.2197 8.62798C11.8147 8.45291 12.9233 8.21334 13.5 8.25006C13.8455 8.27203 14.4477 8.4888 14.7282 8.88948C15.0095 9.29011 15.0769 9.80281 14.9099 10.2628L12.6416 16.5001H14.9993C14.9997 17.7982 14.0612 18.9065 12.7806 19.1199ZM13.5 7.50003C12.6715 7.50003 12 6.82837 12 6.00001C12 5.17156 12.6715 4.5 13.5 4.5C14.3284 4.5 15 5.17156 15 6.00001C15 6.82842 14.3285 7.50003 13.5 7.50003Z"
                                        fill="#FB6638" />
                                </g>
                                <defs>
                                    <clippath id="clip0_6937_1336">
                                        <rect width="24" height="24"
                                            fill="white" />
                                    </clippath>
                                </defs>
                            </svg>

                        </span>
                        <h6 class="footer-nav__title">About</h6>
                        <span class="footer-nav__chevron" aria-hidden="true">
                            <svg width="14" height="14" viewBox="0 0 14 14"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.5 5.25L7 8.75L10.5 5.25"
                                    stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                    </div>
                    <ul class="footer-nav__links">
                        <li><a href="javascript:void(0)"
                                routerLink="/about">About Us</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/press">Press</a></li>
                        <li><a href="javascript:void(0)" routerLink="/app">Get
                                The App</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/provider/ep-providers/newregistration">Experience
                                Partners</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/gift-card">Gift Card</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/claim-voucher">Claim A
                                Voucher</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/sendoso">Sendoso</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/postal">Postal</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/faqs">Faqs</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/influencers">Influencers</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/charities">Charity</a></li>
                        <li><a href="javascript:void(0)"
                                routerLink="/blog">Blog</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <!-- Brand / App / Newsletter / Image -->
    <div class="footer-block">
        <div class="container">
            <div class="row footer-main">
                <!-- Brand & Contact -->
                <div
                    class="col-12 col-md-6 col-xl-3 footer-col footer-col--brand border__right">
                    <div class="footer-logo">
                        <img data-src="assets/images/header-logo-small.png"
                            [src]="web_cdn_url+'assets/images/loading.gif'"
                            class="lazyload" alt="Spur Experiences">
                        <p class="footer-logo-des">
                            We help you create memories that last a lifetime
                            with handpicked experiences around the world.
                        </p>
                    </div>

                    <a class="footer-contact" [href]="'mailto:' + contactEmail">
                        <svg width="18" height="18" viewBox="0 0 14 14"
                            fill="none" xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true">
                            <path
                                d="M9.91602 11.9577H4.08268C2.33268 11.9577 1.16602 11.0827 1.16602 9.04102V4.95768C1.16602 2.91602 2.33268 2.04102 4.08268 2.04102H9.91602C11.666 2.04102 12.8327 2.91602 12.8327 4.95768V9.04102C12.8327 11.0827 11.666 11.9577 9.91602 11.9577Z"
                                stroke="currentcolor" stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"></path>
                            <path
                                d="M9.91634 5.25L8.0905 6.70833C7.48967 7.18667 6.50384 7.18667 5.903 6.70833L4.08301 5.25"
                                stroke="currentcolor" stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                        <span>{{ contactEmail }}</span>
                    </a>
                    <a class="footer-contact" [href]="'tel:' + contactNumber">
                        <svg width="18" height="18" viewBox="0 0 14 14"
                            fill="none" xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true">
                            <path
                                d="M12.654 10.7121C12.654 10.9041 12.6113 11.1015 12.5206 11.2936C12.4299 11.4856 12.3126 11.667 12.1578 11.8377C11.8964 12.1258 11.6083 12.3339 11.2829 12.4673C10.9628 12.6006 10.616 12.67 10.2426 12.67C9.69841 12.67 9.11689 12.542 8.50336 12.2805C7.88984 12.0191 7.27632 11.667 6.66813 11.2242C6.0546 10.7761 5.47308 10.2799 4.91824 9.73042C4.36874 9.17558 3.87258 8.59406 3.42978 7.98587C2.99231 7.37768 2.6402 6.76949 2.38412 6.16664C2.12804 5.55845 2 4.97693 2 4.42209C2 4.05931 2.06402 3.71254 2.19206 3.39244C2.3201 3.067 2.52283 2.76824 2.80559 2.50149C3.14703 2.16539 3.52048 2 3.91527 2C4.06465 2 4.21403 2.03201 4.3474 2.09603C4.48611 2.16005 4.60882 2.25608 4.70485 2.39479L5.94257 4.13934C6.0386 4.27271 6.10795 4.39542 6.15597 4.51279C6.20398 4.62482 6.23066 4.73686 6.23066 4.83822C6.23066 4.96626 6.19331 5.0943 6.11862 5.217C6.04927 5.33971 5.9479 5.46775 5.81986 5.59579L5.4144 6.01725C5.35571 6.07594 5.32904 6.1453 5.32904 6.23066C5.32904 6.27334 5.33438 6.31068 5.34505 6.35336C5.36105 6.39604 5.37706 6.42805 5.38773 6.46006C5.48376 6.63611 5.64914 6.86552 5.88388 7.14294C6.12395 7.42036 6.38003 7.70312 6.65745 7.98587C6.94554 8.26863 7.22297 8.53004 7.50572 8.77011C7.78314 9.00485 8.01254 9.16491 8.19393 9.26094C8.22061 9.27161 8.25262 9.28761 8.28997 9.30361C8.33265 9.31962 8.37533 9.32495 8.42334 9.32495C8.51404 9.32495 8.58339 9.29295 8.64208 9.23426L9.04754 8.83414C9.18091 8.70076 9.30895 8.5994 9.43166 8.53538C9.55436 8.46069 9.67706 8.42334 9.81044 8.42334C9.9118 8.42334 10.0185 8.44468 10.1359 8.4927C10.2532 8.54071 10.376 8.61007 10.5093 8.70076L12.2752 9.95449C12.4139 10.0505 12.51 10.1625 12.5686 10.2959C12.622 10.4293 12.654 10.5627 12.654 10.7121Z"
                                stroke="currentcolor"
                                stroke-miterlimit="10"></path>
                        </svg>
                        <span>{{ contactNumber }}</span>
                    </a>

                    <div class="footer__social">
                        <ul class="header-social-links">
                            <li>
                                <a class="facbook-flip" rel="nofollow"
                                    href="{{ facebookSocialLink }}"
                                    target="_blank" aria-label="Facebook">
                                    <svg width="24" height="24"
                                        viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z"
                                            fill="currentcolor" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a class="instagram-flip" rel="nofollow"
                                    href="{{ instagramSocialLink }}"
                                    target="_blank" aria-label="Instagram">
                                    <svg width="24" height="24"
                                        viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M7.465 1.066C8.638 1.012 9.012 1 12 1C14.988 1 15.362 1.013 16.534 1.066C17.706 1.119 18.506 1.306 19.206 1.577C19.939 1.854 20.604 2.287 21.154 2.847C21.714 3.396 22.146 4.06 22.422 4.794C22.694 5.494 22.88 6.294 22.934 7.464C22.988 8.639 23 9.013 23 12C23 14.987 22.987 15.362 22.934 16.535C22.881 17.705 22.694 18.505 22.422 19.205C22.1459 19.939 21.7132 20.6041 21.154 21.154C20.604 21.714 19.939 22.146 19.206 22.422C18.506 22.694 17.706 22.88 16.536 22.934C15.362 22.988 14.988 23 12 23C9.012 23 8.638 22.987 7.465 22.934C6.295 22.881 5.495 22.694 4.795 22.422C4.06096 22.1459 3.39588 21.7132 2.846 21.154C2.28658 20.6045 1.85354 19.9398 1.577 19.206C1.306 18.506 1.12 17.706 1.066 16.536C1.012 15.361 1 14.987 1 12C1 9.013 1.013 8.638 1.066 7.466C1.119 6.294 1.306 5.494 1.577 4.794C1.85384 4.06014 2.28722 3.39539 2.847 2.846C3.3962 2.2867 4.06059 1.85367 4.794 1.577C5.494 1.306 6.295 1.12 7.465 1.066ZM16.444 3.046C15.284 2.993 14.936 2.982 11.999 2.982C9.062 2.982 8.714 2.993 7.554 3.046C6.481 3.095 5.899 3.274 5.511 3.425C4.998 3.625 4.631 3.862 4.246 4.247C3.88073 4.60179 3.59981 5.0341 3.424 5.512C3.273 5.9 3.094 6.482 3.045 7.555C2.992 8.715 2.981 9.063 2.981 12C2.981 14.937 2.992 15.285 3.045 16.445C3.094 17.518 3.273 18.1 3.424 18.488C3.6 18.965 3.881 19.398 4.246 19.753C4.601 20.118 5.034 20.399 5.511 20.575C5.899 20.726 6.481 20.905 7.554 20.954C8.714 21.007 9.061 21.018 11.999 21.018C14.937 21.018 15.284 21.007 16.444 20.954C17.517 20.905 18.099 20.726 18.487 20.575C19 20.375 19.367 20.138 19.752 19.753C20.117 19.398 20.398 18.965 20.574 18.488C20.725 18.1 20.904 17.518 20.953 16.445C21.006 15.285 21.017 14.937 21.017 12C21.017 9.063 21.006 8.715 20.953 7.555C20.904 6.482 20.725 5.9 20.574 5.512C20.374 4.999 20.137 4.632 19.752 4.247C19.3972 3.88173 18.9649 3.60081 18.487 3.425C18.099 3.274 17.517 3.095 16.444 3.046ZM10.594 15.391C11.3787 15.7176 12.2524 15.7617 13.0659 15.5157C13.8795 15.2697 14.5824 14.7489 15.0546 14.0422C15.5268 13.3356 15.7391 12.4869 15.655 11.6411C15.571 10.7953 15.196 10.005 14.594 9.405C14.2102 9.02148 13.7462 8.72781 13.2353 8.54515C12.7245 8.36248 12.1794 8.29536 11.6395 8.34862C11.0996 8.40187 10.5782 8.57418 10.1128 8.85313C9.64745 9.13208 9.24974 9.51074 8.9483 9.96185C8.64686 10.413 8.44919 10.9253 8.36952 11.462C8.28984 11.9986 8.33015 12.5463 8.48754 13.0655C8.64493 13.5847 8.91548 14.0626 9.27972 14.4647C9.64396 14.8668 10.0928 15.1832 10.594 15.391ZM8.002 8.002C8.52702 7.47698 9.15032 7.0605 9.8363 6.77636C10.5223 6.49222 11.2575 6.34597 12 6.34597C12.7425 6.34597 13.4777 6.49222 14.1637 6.77636C14.8497 7.0605 15.473 7.47698 15.998 8.002C16.523 8.52702 16.9395 9.15032 17.2236 9.8363C17.5078 10.5223 17.654 11.2575 17.654 12C17.654 12.7425 17.5078 13.4777 17.2236 14.1637C16.9395 14.8497 16.523 15.473 15.998 15.998C14.9377 17.0583 13.4995 17.654 12 17.654C10.5005 17.654 9.06234 17.0583 8.002 15.998C6.94166 14.9377 6.34597 13.4995 6.34597 12C6.34597 10.5005 6.94166 9.06234 8.002 8.002ZM18.908 7.188C19.0381 7.06527 19.1423 6.91768 19.2143 6.75397C19.2863 6.59027 19.3248 6.41377 19.3274 6.23493C19.33 6.05609 19.2967 5.87855 19.2295 5.71281C19.1622 5.54707 19.0624 5.39651 18.936 5.27004C18.8095 5.14357 18.6589 5.04376 18.4932 4.97652C18.3275 4.90928 18.1499 4.87598 17.9711 4.87858C17.7922 4.88119 17.6157 4.91965 17.452 4.9917C17.2883 5.06374 17.1407 5.1679 17.018 5.298C16.7793 5.55103 16.6486 5.88712 16.6537 6.23493C16.6588 6.58274 16.7992 6.91488 17.0452 7.16084C17.2911 7.40681 17.6233 7.54723 17.9711 7.5523C18.3189 7.55737 18.655 7.42669 18.908 7.188Z"
                                            fill="currentcolor" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a class="pinterest-flip" rel="nofollow"
                                    href="{{ pinterestSocialLink }}"
                                    target="_blank" aria-label="Pinterest">
                                    <svg width="24" height="24"
                                        viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.99995 14.5C4.99995 10 9.46195 6.5 12.5 6.5C15.538 6.5 18 8.154 18 12C18 15.038 16 17 14 17C12 17 11 15 11.5 12M12 10L8.99995 21.5"
                                            stroke="currentcolor"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
                                            stroke="currentcolor"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a class="linkedin-flip" rel="nofollow"
                                    href="{{ linkedinSocialLink }}"
                                    target="_blank" aria-label="LinkedIn">
                                    <svg width="24" height="24"
                                        viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M9.429 8.969H13.143V10.819C13.678 9.755 15.05 8.799 17.111 8.799C21.062 8.799 22 10.917 22 14.803V22H18V15.688C18 13.475 17.465 12.227 16.103 12.227C14.214 12.227 13.429 13.572 13.429 15.687V22H9.429V8.969ZM2.57 21.83H6.57V8.799H2.57V21.83ZM7.143 4.55C7.14315 4.88528 7.07666 5.21724 6.94739 5.52659C6.81812 5.83594 6.62865 6.11651 6.39 6.352C6.15064 6.59012 5.86671 6.77874 5.55442 6.90708C5.24214 7.03543 4.90763 7.10098 4.57 7.1C3.8896 7.09847 3.23691 6.83029 2.752 6.353C2.5143 6.11665 2.32553 5.83575 2.1965 5.52637C2.06746 5.21699 2.00069 4.88521 2 4.55C2 3.873 2.27 3.225 2.753 2.747C3.2367 2.26788 3.89018 1.99938 4.571 2C5.253 2 5.907 2.269 6.39 2.747C6.873 3.225 7.143 3.873 7.143 4.55Z"
                                            fill="currentcolor" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a class="tiktok-flip" rel="nofollow"
                                    href="{{ tiktokSocialLink }}"
                                    target="_blank" aria-label="TikTok">
                                    <svg width="24" height="24"
                                        viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M16.6002 5.82C15.9167 5.03953 15.5401 4.0374 15.5402 3H12.4502V15.4C12.4268 16.0712 12.1437 16.7071 11.6605 17.1735C11.1773 17.6399 10.5318 17.9004 9.86016 17.9C8.44016 17.9 7.26016 16.74 7.26016 15.3C7.26016 13.58 8.92016 12.29 10.6302 12.82V9.66C7.18016 9.2 4.16016 11.88 4.16016 15.3C4.16016 18.63 6.92016 21 9.85016 21C12.9902 21 15.5402 18.45 15.5402 15.3V9.01C16.7932 9.90985 18.2975 10.3926 19.8402 10.39V7.3C19.8402 7.3 17.9602 7.39 16.6002 5.82Z"
                                            fill="currentcolor" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Get The App -->
                <div
                    class="col-12 col-md-6 col-xl-3 footer-col footer-col--app border__right">
                    <a class="footer-link-title" href="javascript:void(0)"
                        routerLink="/app">Get The App</a>
                    <p class="footer-col__text">Discover, book and manage
                        experiences on the go.</p>
                    <div class="download-buttons">
                        <a class="store-btn" [href]="androidAppDownloadLink"
                            target="_blank" rel="noopener noreferrer">
                            <img src="../../../assets/images/google-pay.png"
                                alt>
                        </a>
                        <a class="store-btn" [href]="iphoneAppDownloadLink"
                            target="_blank" rel="noopener noreferrer">
                            <img src="../../../assets/images/app-store.png" alt>
                        </a>
                    </div>
                </div>

                <!-- Newsletter -->
                <div
                    class="col-12 col-md-6 col-xl-3 footer-col footer-col--newsletter">
                    <div class="footer-link-title">Stay in touch</div>
                    <p class="footer-col__text">Get the latest experiences and
                        exclusive offers straight to your inbox.</p>
                    <div class="new-letter-box">
                        <form [formGroup]="SubscribeForm"
                            (ngSubmit)="onSubscribeSubmit()"
                            class="d-flex newsHead">
                            <div class="inputMail">
                                <input type="email" required="true"
                                    formControlName="email"
                                    placeholder="Enter email" name="email"
                                    autocomplete="email"
                                    [ngClass]="{ 'is-invalid': submitted && subscribeFormCtrl?.email?.errors }">
                            </div>
                            <div class="inputSubmit">
                                <button type="submit" class="submit-input"
                                    aria-label="Subscribe"></button>
                            </div>
                        </form>
                        @if(subscribe_error){
                        <div
                            class="help-block">{{subscribe_error_message}}</div>
                        }
                    </div>
                </div>

                <!-- Collect Moments image -->
                <div
                    class="col-12 col-md-6 col-xl-3 footer-col footer-col--visual">
                    <img class="footer-visual"
                        src="assets/images/collect-moments.png"
                        alt="Collect Memories Not Things" loading="lazy"
                        width="280" height="280">
                </div>
            </div>
        </div>
    </div>
    <div class="copyright-block">
        <div class="container">
            <div class="row footer-bottom align-items-center">
                <div class="col-12 col-lg-4">
                    <span class="copyright-text">© {{currentYear}}, Spur
                        Experiences</span>
                </div>
                <div class="col-12 col-lg-4">
                    <nav class="footer-legal" aria-label="Legal">
                        <a href="javascript:void(0);"
                            routerLink="/terms-conditions">Terms of Use</a>
                        <span class="footer-legal__sep" aria-hidden="true">|</span>
                        <a href="javascript:void(0);"
                            routerLink="/privacy-policy">Privacy Policy</a>
                        <span class="footer-legal__sep" aria-hidden="true">|</span>
                        <a [href]="sitemapUrl" target="_blank"
                            rel="noopener noreferrer">Sitemap</a>
                    </nav>
                </div>
                <div class="col-12 col-lg-4">
                    <div class="payment-methods" aria-label="Accepted payment methods">
                        <span class="payment-badge" title="Cards">
                            <img src="assets/images/card_img.png" alt="Cards"
                                loading="lazy">
                        </span>
                        <span class="payment-badge" title="PayPal">
                            <img src="assets/images/paypal_img.png" alt="PayPal"
                                loading="lazy">
                        </span>
                        <span class="payment-badge" title="Google Pay">
                            <img src="assets/images/google_pay.png" alt="Google Pay"
                                loading="lazy">
                        </span>
                        <span class="payment-badge" title="Apple Pay">
                            <img src="assets/images/apple_pay.png" alt="Apple Pay"
                                loading="lazy">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
}
